export default __webpack_public_path__ + "static/media/contactUs.3ca6b72a.svg";